export default "2f69d096bbde365c.ttf"